<script setup lang="ts">
import { ComboboxInput, type ComboboxInputEmits, type ComboboxInputProps, useForwardPropsEmits } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

const properties = defineProps<
  ComboboxInputProps & {
    class?: HTMLAttributes['class']
  }
>()

const emits = defineEmits<ComboboxInputEmits>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = properties

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProperties, emits)
</script>

<template>
  <ComboboxInput v-bind="forwarded" :class="cn('atabix-combobox-input', properties.class)">
    <slot />
  </ComboboxInput>
</template>

<style lang="scss">
.atabix-combobox-input {
  @apply flex;
  @apply h-10;
  @apply pl-9;
  @apply w-full;
  @apply border-b;
  @apply border-border;
  @apply bg-transparent;
  @apply pr-3;
  @apply py-1;
  @apply text-sm;
  @apply shadow-sm;
  @apply transition-colors;

  &::file-selector-button {
    @apply border-0;
    @apply bg-transparent;
    @apply text-sm;
    @apply font-medium;
  }

  &:disabled {
    @apply cursor-not-allowed;
    @apply opacity-50;
  }
  &:focus-visible {
    @apply ring-0;
    @apply shadow-none;
    @apply outline-none;
    // @apply ring-button-outline-bg;
  }
  &::placeholder {
    @apply text-foreground-placeholder;
  }
}
</style>
